<template>
  <div>
    <v-app-bar :color="`${$primaryColor} darken-2`" app clipped-left dense dark>
      <v-app-bar-nav-icon
        v-if="$vuetify.breakpoint.smAndDown && hasNav"
        @click="onToggleNavbar"
      />

      <!-- <v-spacer v-if="$vuetify.breakpoint.smAndDown && hasNav" /> -->

      <v-toolbar-title class="justify-center">
        <router-link to="/">
          <v-row
            :class="{
              'ml-1 mr-1 mb-1': $vuetify.breakpoint.smAndUp
            }"
            class="ml-1 mr-1 mb-1 "
          >
            <v-img
              :src="require('@/assets/image/hrlogo.png')"
              height="39"
              width="39"
              style="cursor:pointer"
              eager
              class="mr-1 ml-n1"
              v-if="$vuetify.breakpoint.smAndUp"
            />
            <v-img
              :src="require('@/assets/image/CMUMISLogo.svg')"
              height="39"
              width="124"
              style="cursor:pointer"
              eager
              class="mr-1"
            /> </v-row
        ></router-link>
      </v-toolbar-title>

      <v-spacer />

      <dashboard-employee />

      <dashboard-noti />

      <div v-if="$vuetify.breakpoint.mdAndUp">
        <v-btn v-if="$route.fullPath === '/'" @click="onHome" icon>
          <v-icon>mdi-home-outline</v-icon>
        </v-btn>
        <router-link v-else to="/">
          <v-btn icon>
            <v-icon>mdi-home-outline</v-icon>
          </v-btn>
        </router-link>
      </div>
      <v-dialog v-model="announce" max-width="815">
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" icon>
            <v-icon>mdi-bullhorn-outline</v-icon>
          </v-btn>
        </template>

        <v-card>
          <dashboard-carousels />
        </v-card>
      </v-dialog>

      <v-btn @click="onToggleNavInfo" icon>
        <v-avatar color="white" size="36">
          <span
            v-if="picEmpPath.type === 'icon'"
            v-text="picEmpPath.src"
            class="white--text"
            style="font-size:18px"
          />
          <v-img
            v-if="picEmpPath.type === 'img'"
            :src="picEmpPath.src"
            contain
          />
        </v-avatar>
        <!-- <span v-text="emailCMU" class="px-1 text-none" /> -->
      </v-btn>
    </v-app-bar>

    <navigation-info v-model="navInfo" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import DashboardCarousels from '@/components/dashboard/DashboardCarousels'
import DashboardNoti from '@/components/dashboard/DashboardNoti'
import DashboardEmployee from '@/components/dashboard/DashboardEmployee'

export default {
  components: {
    DashboardCarousels,
    DashboardNoti,
    DashboardEmployee
  },

  props: {
    hasNav: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      menuList: [],
      navInfo: false,
      navInfoTab: 0
    }
  },

  computed: {
    ...mapState({
      status: state => state.navbar.status,
      visible: state => state.navbar.visible
    }),

    picEmpPath() {
      let res = { type: 'icon', src: 'Na', color: 'primary lighten-1' }
      const picEmpPath = this.$store.state.auth.picEmpPath
      if (picEmpPath) {
        res = {
          type: 'img',
          src: picEmpPath,
          color: 'primary lighten-4'
        }
      } else {
        let acronym = ''
        const firstNameEng = this.$store.state.auth.firstNameEng
        const lastNameEng = this.$store.state.auth.lastNameEng
        if (firstNameEng && lastNameEng) {
          acronym = firstNameEng.substr(0, 1) + lastNameEng.substr(0, 1)
        } else if (firstNameEng) {
          acronym = firstNameEng.substr(0, 2)
        } else if (lastNameEng) {
          acronym = lastNameEng.substr(0, 2)
        } else {
          acronym = 'Na'
        }
        res = { type: 'icon', src: acronym, color: 'primary lighten-1' }
      }

      return res
    },

    emailCMU() {
      return this.$store.state.auth.emailCMU
        ? this.$store.state.auth.emailCMU
        : ''
    }
  },

  methods: {
    onToggleNavbar() {
      this.$emit('onToggleNav')
    },

    onToggleNavInfo() {
      this.navInfo = !this.navInfo
    },

    onHome() {
      this.$vuetify.goTo(0)
    }
  }
}
</script>
